module.exports = __webpack_public_path__ + "static/media/SolutionSvgEng.d97a7e2e.svg";